import React, { Component } from 'react';
import A from '../Anchor/Anchor';
import { FiMinus, FiPlus } from 'react-icons/fi';

import './CartQuantity.scss';

class CartQuantity extends Component {
  render() {
    const {
      value,
      onIncrement,
      onDecrement,
      primaryColor,
      uiVariantButton,
      availableLessThanRequested,
      isBig = false,
      isInverse = false,
      disabled,
    } = this.props;

    const minusDisabled = value === 1;
    const plusDisabled = value === 99;

    const getBorderRadius = (uiVariantButton, isBig) => {
      switch (uiVariantButton) {
        case '1':
          return isBig ? '12px' : '8px';
        case '2':
          return '0';
        case '3':
          return isBig ? '6px' : '4px';
      }
    };

    return (
      <div className={`quantity ${isBig ? 'big' : ''}`}>
        <A
          href="#"
          onClick={onDecrement}
          className={`minus ${minusDisabled ? 'btn-outline' : 'btn-primary'}`}
          style={{
            backgroundColor: isInverse ? '#fff' : 'primaryColor',
            color: isInverse || minusDisabled ? primaryColor : '#fff',
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          style={{
            borderRadius: getBorderRadius(uiVariantButton, isBig),
          }}
        >
          <FiMinus />
        </A>

        <span
          className={`value ${
            availableLessThanRequested ? 'not-available' : ''
          }`}
        >
          {value}
        </span>

        <A
          href="#"
          onClick={onIncrement}
          className={`plus ${plusDisabled ? 'btn-outline' : 'btn-primary'}`}
          style={{
            backgroundColor: isInverse ? '#fff' : 'primaryColor',
            color: isInverse || plusDisabled ? primaryColor : '#fff',
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          style={{
            borderRadius: getBorderRadius(uiVariantButton, isBig),
          }}
        >
          <FiPlus />
        </A>
      </div>
    );
  }
}

export default CartQuantity;
